import { CustomFieldType, CustomFieldValueDto } from "generated/CoreApi_v1";
import { TFunction } from "i18next";
import { Formaters } from "lib/Formaters";
import moment from "moment";
import { IMask } from 'react-imask';

export interface CustomFieldData {
    label: string;
    fieldValue: string | null;
}

export function CustomFieldDataResolve(field: CustomFieldValueDto, t: TFunction): CustomFieldData {
    ////////////////////////////////////////////////////////////////////////////
    const {
        fieldType,
        fieldValue,
        label,
        textField,
        numericField,
    } = field;

    switch (fieldType) {
        case CustomFieldType.Text:
        case CustomFieldType.Uuid:
            if (textField?.displayFormat) {
                var maskOptions = {
                    mask: textField?.displayFormat
                };
                const mask = IMask.createMask(maskOptions);
                mask.resolve(fieldValue ?? "");

                return {
                    label,
                    fieldValue: mask.value
                };
            }
            else {
                return {
                    label,
                    fieldValue
                };
            }
        case CustomFieldType.Numeric:
            return {
                label,
                fieldValue: Formaters.number(Number(fieldValue), numericField?.precision ?? 0)
            };
        case CustomFieldType.Boolean:
            return {
                label,
                fieldValue: fieldValue == "True" ? t("Literal.Yes", { ns: "shared" }).toUpperCase() : t("Literal.No", { ns: "shared" }).toUpperCase()
            };
        case CustomFieldType.DateTime:
            return {
                label,
                fieldValue: `${moment(fieldValue).format("L")} ${moment(fieldValue).format("LT")}`
            };
        case CustomFieldType.Date:
            return {
                label,
                fieldValue: moment(fieldValue).format("L")
            };
        case CustomFieldType.Time:
            return {
                label,
                fieldValue: moment(fieldValue).format("LT")
            };
        case CustomFieldType.ValueSelection:
            return {
                label,
                fieldValue
            };
        default:
            return {
                label,
                fieldValue
            };
    }
}
